import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@react-pdf/renderer';
import {
    styles, preparePdfTheme, formatDate,
    PdfDocument, MetaCard, PartiesRow, LineItemsTable, TotalsCard, InfoCard,
} from './pdfCommon';

export { THEMES } from './pdfCommon';

/**
 * GrowSquare CRM sales order. Design, colour themes and shared pieces live in pdfCommon.js.
 * Optional props: theme (see THEMES in pdfCommon.js), logoSrc.
 */
const SalesOrderPDF = ({ data, companyData, tableItem, tableColum, currencySettings, Calculation, profile, accountJsonData, theme, logoSrc }) => {
    const logo = logoSrc || companyData?.accountLogo;
    const p = {
        ...preparePdfTheme(theme, logo),
        logoRatio: companyData?.logoSize ? companyData.logoSize.width / companyData.logoSize.height : 1,
    };

    return (
        <PdfDocument
            documentTitle={`Sales Order ${data?.salesOrderNumber || ''}`}
            headline="SALES ORDER"
            number={data?.salesOrderNumber}
            p={p}
            companyData={companyData}
            profile={profile}
        >
            <MetaCard
                items={[
                    data?.purchaseOrderNumber ? ['PO number', data?.purchaseOrderNumber] : null,
                    ['Due date', formatDate(data?.dueDate, profile)],
                ]}
            />

            <PartiesRow companyData={companyData} data={data} accountJsonData={accountJsonData} />

            <LineItemsTable
                tableItem={tableItem}
                tableColum={tableColum}
                currencySettings={currencySettings}
                profile={profile}
                p={p}
            />

            <View style={styles.totalsRow} wrap={false}>
                <TotalsCard Calculation={Calculation} currencySettings={currencySettings} p={p} />
            </View>

            {data?.termsAndCondition ? (
                <InfoCard title="Terms and Conditions" html={data.termsAndCondition} p={p} style={{ marginTop: 14 }} />
            ) : null}
        </PdfDocument>
    );
};

SalesOrderPDF.propTypes = {
    data: PropTypes.object.isRequired,
    companyData: PropTypes.object.isRequired,
    tableItem: PropTypes.array.isRequired,
    tableColum: PropTypes.array.isRequired,
    currencySettings: PropTypes.object.isRequired,
    Calculation: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    accountJsonData: PropTypes.object.isRequired,
    theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    logoSrc: PropTypes.string,
};

SalesOrderPDF.defaultProps = {
    theme: 'growsquare',
    logoSrc: undefined,
};

export default SalesOrderPDF;